import { ModuleWithProviders, NgModule } from '@angular/core';

import { DefaultConfig } from './default-config';
import { DndConfig } from './dnd-config';
import { DndHandleDirective } from './dnd-handle.directive';
import { DndPlaceholderDirective } from './dnd-placeholder.directive';
import { DraggableDirective } from './draggable.directive';
import { DroppableDirective } from './droppable.directive';
import { StateService } from './state.service';

@NgModule({
  declarations: [
    DroppableDirective,
    DraggableDirective,
    DndHandleDirective,
    DndPlaceholderDirective
  ],
  exports: [
    DroppableDirective,
    DraggableDirective,
    DndHandleDirective,
    DndPlaceholderDirective
  ]
})
export class DragAndDropModule {
  static forRoot(): ModuleWithProviders<DragAndDropModule> {
    return {
      ngModule: DragAndDropModule,
      providers: [
        StateService,
        {
          provide: DndConfig,
          useClass: DefaultConfig
        }
      ]
    };
  }
}
